import {useCallback, useRef} from "react";

export type RegisterSubmit = (submit: (() => Promise<void>) | null) => void;

// Lets a child form hand its submit to the parent (which owns the CTA) without lifting the form state.
export const useRegisteredSubmit = () => {
    const submitRef = useRef<(() => Promise<void>) | null>(null);

    const registerSubmit: RegisterSubmit = useCallback((submit) => {
        submitRef.current = submit;
    }, []);

    const submit = useCallback(() => submitRef.current?.(), []);

    return {registerSubmit, submit};
};
import {useCallback, useRef} from "react";

export type RegisterSubmit = (submit: (() => Promise<void>) | null) => void;

// Lets a child form hand its submit to the parent (which owns the CTA) without lifting the form state.
export const useRegisteredSubmit = () => {
    const submitRef = useRef<(() => Promise<void>) | null>(null);

    const registerSubmit: RegisterSubmit = useCallback((submit) => {
        submitRef.current = submit;
    }, []);

    const submit = useCallback(() => submitRef.current?.(), []);

    return {registerSubmit, submit};
};
